import { render, staticRenderFns } from "./DirectDelivery.vue?vue&type=template&id=465327e9&scoped=true&"
import script from "./DirectDelivery.vue?vue&type=script&lang=js&"
export * from "./DirectDelivery.vue?vue&type=script&lang=js&"
import style0 from "./DirectDelivery.vue?vue&type=style&index=0&id=465327e9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465327e9",
  null
  
)

export default component.exports